import { Component, Input } from '@angular/core';
import { ContainerMovementListItem } from '../../../Container/model/ContainerMovementListItem';
import { ContainerJobContact } from '../../../Container/model/ContainerJobContact';

@Component({
  selector: 'app-container-job-delivery-location-details',
  standalone: true,
  imports: [],
  templateUrl: './container-job-delivery-location-details.component.html',
  styleUrl: './container-job-delivery-location-details.component.scss'
})
export class ContainerJobDeliveryLocationDetailsComponent {
  @Input()
  currentLegData?: ContainerMovementListItem;

  @Input()
  toJobContact?: ContainerJobContact | null;
}
